(function () {
  class LogoPopupDisplay extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', this.onXtraPowerTriggerEvent.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name + ':logoPopupContainer';
      this._logoPopupContainer = undefined;
      this._logoFrame = undefined;
      this._logoAnim = undefined;
      this._activeText = undefined;
      this._pulseAnim = undefined;
      this._xtraPowerTriggerTask = undefined;
    }

    update(delta, time) {}

    onGameConfigEvent() {
      this._logoPopupContainer = resourceManager.get(this._jsonPath);
      this._logoPopupContainer.visible = false;

      this._logoFrame = resourceManager.get(this._jsonPath + ':logoPopupFrame');
      this._logoFrame.visible = false;

      this._logoAnim = resourceManager.get(this._jsonPath + ':logoPopupAnim');
      this._logoAnim.gotoAndStop(0);
      this._logoAnim.visible = false;

      this._activeText = resourceManager.get(this._jsonPath + ':activeNextFeatureText');
      this._activeText.visible = false;
    }

    onXtraPowerTriggerEvent(task) {
      this._xtraPowerTriggerTask = task;
      this._xtraPowerTriggerTask.join();

      this.showXtraPowerTriggerMessageIntro();
    }

    showXtraPowerTriggerMessageIntro() {
      this._logoPopupContainer.scale.set(0);
      this._logoPopupContainer.visible = true;
      this._logoFrame.visible = true;
      this._activeText.visible = true;
      this._logoAnim.visible = true;
      this._logoAnim.gotoAndPlay(0);

      gsap.to(this._logoPopupContainer.scale, {
        x: 1,
        y: 1,
        duration: 0.25,
        ease: 'power1.Out',
        onComplete: () => {
          this._logoPopupContainer.scale.set(1);
          this.showXtraPowerTriggerMessagePause();
        },
      });
    }

    showXtraPowerTriggerMessagePause() {
      const self = this;
      timerManager.addTimeout(5000, function () {
        self.showXtraPowerTriggerMessageOutro();
      });
    }

    showXtraPowerTriggerMessageOutro() {
      gsap.to(this._logoPopupContainer.scale, {
        x: 0,
        y: 0,
        duration: 0.25,
        ease: 'power1.Out',
        onComplete: () => {
          this.showXtraPowerTriggerMessageEnd();
        },
      });
    }

    showXtraPowerTriggerMessageEnd() {
      this._logoPopupContainer.scale.set(1);
      this._logoPopupContainer.visible = false;
      this._logoFrame.visible = false;
      this._activeText.visible = false;
      this._logoAnim.visible = false;
      this._logoAnim.gotoAndStop(0);

      this._xtraPowerTriggerTask.leave();
    }

    startLogoPulse() {
      this._logoFrame.visible = false;
      this._activeText.visible = false;
      this._logoAnim.scale.set(0);
      this._logoAnim.visible = true;
      this._logoAnim.gotoAndPlay(0);
      this._logoPopupContainer.visible = true;

      gsap.to(this._logoAnim.scale, {
        x: 1,
        y: 1,
        duration: 0.25,
        ease: 'power1.Out',
        onComplete: () => {
          this._pulseAnim = gsap.to(this._logoAnim.scale, {
            x: 0.9,
            y: 0.9,
            duration: 0.25,
            yoyo: true,
            repeat: -1,
            ease: 'power1.inOut',
          });
        },
      });
    }

    stopLogoPulse() {
      this._pulseAnim.kill();
      this._pulseAnim = undefined;

      gsap.to(this._logoAnim.scale, {
        x: 0,
        y: 0,
        duration: 0.25,
        ease: 'power1.In',
        onComplete: () => {
          this._logoAnim.scale.set(1);
          this._logoAnim.visible = false;
          this._logoAnim.gotoAndStop(0);
          this._logoPopupContainer.visible = false;
        },
      });
    }

    onLayoutChange() {}
  }

  let creator = function (json) {
    return new LogoPopupDisplay();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('logoPopupDisplay', creator, initialise, filesRequired);
})();
